import React from 'react';
import { connect } from 'react-redux';
import {Producto_Comercial} from '../constants/constants'
import { getVelidateIsMascota } from '../mascotas/util-functions';

const mapState = (state) => {
    return {
        "poliza": state.polizas.poliza
    }
}

class VehiculoPoliza extends React.Component {
	getImgFromValidateIsMascota = (isMascota) => {
		let imgVehiculo = isMascota ? require("../img/mascota.svg") : require("../img/circle-vehiculo.svg"); 
	    return imgVehiculo;
	}
    render() {
        let imgVehiculo;
		const isMascota = getVelidateIsMascota(this.props.poliza.generales.productoComercial.trim());

        switch (this.props.poliza.generales.cveRamo) {
            case "A":
                imgVehiculo = require("../img/circle-vehiculo.svg");
                break;
            case "G":
                imgVehiculo = require("../img/circle-vehiculo.svg");
                break;
            case "D":
                imgVehiculo = this.getImgFromValidateIsMascota(isMascota); 
                break;
            case "V":
                imgVehiculo = require("../img/circle-vehiculo.svg");
                break;
        }
        
        return <div className="card">
    		<i><img src={ imgVehiculo } alt="" className="pad-right-10" /></i>
			<span className="blue-text detalle-seccion">{ isMascota ? "Mascota" : "Vehículo"}</span>
    		<ul className="list-divider mt-25">
			{ !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Descripción</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="marca">{ this.props.poliza.vehiculo.descripcion }</p>
    					</div>
    				</div>
    			</li>
	         }
			 { !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Modelo</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="modelo">{ this.props.poliza.vehiculo.modelo }</p>
    					</div>
    				</div>
    			</li>
	         }
			 { !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Placas</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="placas">{ this.props.poliza.vehiculo.placas }</p>
    					</div>
    				</div>
    			</li>
	         }
			 { !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Número de motor</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="numMotor">{ this.props.poliza.vehiculo.numMotor }</p>
    					</div>
    				</div>
    			</li>
	         }
			 { !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Número de serie</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="numSerie">{ this.props.poliza.vehiculo.numSerie }</p>
    					</div>
    				</div>
    			</li>
	         }
			 { !isMascota &&
    			<li className="clearfix">
    				<div className="pull-left">
    					<p><b>Tipo de uso</b></p>
    				</div>
    				<div className="pull-right">
    					<div className="gray-text texto15">
    						<p name="tipoUso">{ this.props.poliza.vehiculo.tipoUso }</p>
    					</div>
    				</div>
    			</li>
	         }
			 {/* finish autos poliza
				 start mascota poliza  */}
				{ (isMascota) &&
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Tipo mascota</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="tipoUso">{this.props.poliza.infoMascota  && this.props.poliza.infoMascota.tipo}</p>
							</div>
						</div>
					</li>
	            }
				{ (isMascota) &&
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Nombre</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="tipoUso">{ this.props.poliza.infoMascota  && this.props.poliza.infoMascota.nombre }</p>
							</div>
						</div>
					</li>
	            }
				{ (isMascota) &&
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Raza</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="tipoUso">{ this.props.poliza.infoMascota  && this.props.poliza.infoMascota.raza }</p>
							</div>
						</div>
					</li>
	            }
				{ (isMascota) &&
					<li className="clearfix">
						<div className="pull-left">
							<p><b>Edad</b></p>
						</div>
						<div className="pull-right">
							<div className="gray-text texto15">
								<p name="tipoUso">{ this.props.poliza.infoMascota  && this.props.poliza.infoMascota.edad }</p>
							</div>
						</div>
					</li>
	            }
				{/* finish mascota poliza */}
    		</ul>
    	</div>
    }
}

export default connect(mapState)(VehiculoPoliza);


// WEBPACK FOOTER //
// ./src/home/vehiculo.cmpt.js